<template>
    <b-row id="futurocoin_withdraw_component"
           class="futurocoin-withdraw-component"
           no-gutters>
        <b-col lg="4" md="4" cols="12" class="futurocoin-withdraw-info">
            <p class="color--gray">{{ withdraw.date }} you can withdraw {{ withdraw.percent }}%
                of your FuturoCoins</p>
        </b-col>
    </b-row>
</template>

<script>
    export default {
        computed: {
            withdraw () {
                return this.$store.getters.futurocoinWithdraw[0] ? this.$store.getters.futurocoinWithdraw[0] : ''
            }
        }
    }
</script>

<style lang="scss" scoped>
    @media(min-width: 992px){
        .futurocoin-withdraw-component{
            justify-content: flex-end;
        }

        .futurocoin-withdraw-info{
            padding: 0 20px !important;
        }
    }

    @media(max-width:991px){
        .futurocoin-withdraw-component{
            margin-bottom: 30px;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/layout/partials/section/content/futurocoin/FuturocoinWithdraw.vue